"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToRuleMappingStatus = exports.RuleMappingStatusSchema = exports.RuleMappingStatus = exports.castToRuleStatus = exports.RuleStatusSchema = exports.RuleStatus = exports.castToBudgetPlanStatus = exports.BudgetPlanStatusSchema = exports.BudgetPlanStatus = exports.castToVoucherDefinitionStatus = exports.VoucherDefinitionStatusSchema = exports.VoucherDefinitionStatus = exports.castToVoucherCodeStatus = exports.VoucherCodeStatusSchema = exports.VoucherCodeStatus = exports.castToAppleChannelKeywordStatus = exports.AppleChannelKeywordStatusSchema = exports.AppleChannelKeywordStatus = exports.castToAppleChannelRegionStatus = exports.AppleChannelRegionStatusSchema = exports.AppleChannelRegionStatus = exports.castToAppleChannelStatus = exports.AppleChannelStatusSchema = exports.AppleChannelStatus = exports.castToCampaignStatus = exports.CampaignStatusSchema = exports.CampaignStatus = exports.castToTeamStatus = exports.TeamStatusSchema = exports.TeamStatus = exports.castToTierStatus = exports.TierStatusSchema = exports.TierStatus = exports.castToUserStatus = exports.UserStatusSchema = exports.UserStatus = void 0;
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "A";
    UserStatus["DISABLED"] = "D";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
exports.UserStatusSchema = (0, core_1.StringUnion)([UserStatus.ACTIVE, UserStatus.DISABLED], {
    title: "User Status",
});
exports.castToUserStatus = (0, cast_1.castToEnum)(UserStatus);
var TierStatus;
(function (TierStatus) {
    TierStatus["ACTIVE"] = "A";
    TierStatus["DISABLED"] = "D";
})(TierStatus = exports.TierStatus || (exports.TierStatus = {}));
exports.TierStatusSchema = (0, core_1.StringUnion)([TierStatus.ACTIVE, TierStatus.DISABLED], {
    title: "Tier Status",
});
exports.castToTierStatus = (0, cast_1.castToEnum)(TierStatus);
var TeamStatus;
(function (TeamStatus) {
    TeamStatus["ACTIVE"] = "A";
    // User the paused the team, so no more activity should take place
    // The Team may still be billed for activity which has occurred on their account to date.
    // But jobs etc should not be run.
    TeamStatus["SUSPENDED"] = "S";
    TeamStatus["DELETED"] = "D";
})(TeamStatus = exports.TeamStatus || (exports.TeamStatus = {}));
exports.TeamStatusSchema = (0, core_1.StringUnion)([TeamStatus.ACTIVE, TeamStatus.SUSPENDED, TeamStatus.DELETED], {
    title: "Team Status",
});
exports.castToTeamStatus = (0, cast_1.castToEnum)(TeamStatus);
var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["ACTIVE"] = "A";
    // The campaign should be considered READ ONLY (not sync, no budget updates, etc)
    CampaignStatus["PASSIVE"] = "P";
    CampaignStatus["DELETED"] = "D";
})(CampaignStatus = exports.CampaignStatus || (exports.CampaignStatus = {}));
exports.CampaignStatusSchema = (0, core_1.StringUnion)([CampaignStatus.ACTIVE, CampaignStatus.PASSIVE, CampaignStatus.DELETED], {
    title: "Campaign Status",
});
exports.castToCampaignStatus = (0, cast_1.castToEnum)(CampaignStatus);
// Apple channels
var AppleChannelStatus;
(function (AppleChannelStatus) {
    AppleChannelStatus["ACTIVE"] = "A";
    AppleChannelStatus["DISABLED"] = "D";
})(AppleChannelStatus = exports.AppleChannelStatus || (exports.AppleChannelStatus = {}));
exports.AppleChannelStatusSchema = (0, core_1.StringUnion)([AppleChannelStatus.ACTIVE, AppleChannelStatus.DISABLED], {
    title: "Apple Channel Status",
});
exports.castToAppleChannelStatus = (0, cast_1.castToEnum)(AppleChannelStatus);
var AppleChannelRegionStatus;
(function (AppleChannelRegionStatus) {
    AppleChannelRegionStatus["ACTIVE"] = "A";
    AppleChannelRegionStatus["DISABLED"] = "D";
})(AppleChannelRegionStatus = exports.AppleChannelRegionStatus || (exports.AppleChannelRegionStatus = {}));
exports.AppleChannelRegionStatusSchema = (0, core_1.StringUnion)([AppleChannelRegionStatus.ACTIVE, AppleChannelRegionStatus.DISABLED], {
    title: "Apple Channel Region Status",
});
exports.castToAppleChannelRegionStatus = (0, cast_1.castToEnum)(AppleChannelRegionStatus);
var AppleChannelKeywordStatus;
(function (AppleChannelKeywordStatus) {
    AppleChannelKeywordStatus["ACTIVE"] = "A";
    AppleChannelKeywordStatus["DISABLED"] = "D";
    AppleChannelKeywordStatus["INVALID"] = "I";
})(AppleChannelKeywordStatus = exports.AppleChannelKeywordStatus || (exports.AppleChannelKeywordStatus = {}));
exports.AppleChannelKeywordStatusSchema = (0, core_1.StringUnion)([
    AppleChannelKeywordStatus.ACTIVE,
    AppleChannelKeywordStatus.DISABLED,
    AppleChannelKeywordStatus.INVALID,
], {
    title: "Apple Channel Status",
});
exports.castToAppleChannelKeywordStatus = (0, cast_1.castToEnum)(AppleChannelKeywordStatus);
// Budgets
var VoucherCodeStatus;
(function (VoucherCodeStatus) {
    VoucherCodeStatus["ACTIVE"] = "A";
    VoucherCodeStatus["DISABLED"] = "D";
})(VoucherCodeStatus = exports.VoucherCodeStatus || (exports.VoucherCodeStatus = {}));
exports.VoucherCodeStatusSchema = (0, core_1.StringUnion)([VoucherCodeStatus.ACTIVE, VoucherCodeStatus.DISABLED], {
    title: "Voucher Code Status",
});
exports.castToVoucherCodeStatus = (0, cast_1.castToEnum)(VoucherCodeStatus);
var VoucherDefinitionStatus;
(function (VoucherDefinitionStatus) {
    VoucherDefinitionStatus["ACTIVE"] = "A";
    VoucherDefinitionStatus["DISABLED"] = "D";
})(VoucherDefinitionStatus = exports.VoucherDefinitionStatus || (exports.VoucherDefinitionStatus = {}));
exports.VoucherDefinitionStatusSchema = (0, core_1.StringUnion)([VoucherDefinitionStatus.ACTIVE, VoucherDefinitionStatus.DISABLED], {
    title: "Voucher Definition Status",
});
exports.castToVoucherDefinitionStatus = (0, cast_1.castToEnum)(VoucherDefinitionStatus);
var BudgetPlanStatus;
(function (BudgetPlanStatus) {
    BudgetPlanStatus["ACTIVE"] = "A";
    BudgetPlanStatus["DISABLED"] = "D";
})(BudgetPlanStatus = exports.BudgetPlanStatus || (exports.BudgetPlanStatus = {}));
exports.BudgetPlanStatusSchema = (0, core_1.StringUnion)([BudgetPlanStatus.ACTIVE, BudgetPlanStatus.DISABLED], {
    title: "Budget Plan Status",
});
exports.castToBudgetPlanStatus = (0, cast_1.castToEnum)(BudgetPlanStatus);
var RuleStatus;
(function (RuleStatus) {
    RuleStatus["ACTIVE"] = "A";
    RuleStatus["DISABLED"] = "D";
})(RuleStatus = exports.RuleStatus || (exports.RuleStatus = {}));
exports.RuleStatusSchema = (0, core_1.StringUnion)([RuleStatus.ACTIVE, RuleStatus.DISABLED], {
    title: "Budget Plan Status",
});
exports.castToRuleStatus = (0, cast_1.castToEnum)(RuleStatus);
var RuleMappingStatus;
(function (RuleMappingStatus) {
    RuleMappingStatus["ACTIVE"] = "A";
    RuleMappingStatus["DISABLED"] = "D";
})(RuleMappingStatus = exports.RuleMappingStatus || (exports.RuleMappingStatus = {}));
exports.RuleMappingStatusSchema = (0, core_1.StringUnion)([RuleMappingStatus.ACTIVE, RuleMappingStatus.DISABLED], {
    title: "Budget Plan Status",
});
exports.castToRuleMappingStatus = (0, cast_1.castToEnum)(RuleMappingStatus);
